import script from "./SchoolSettingsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SchoolSettingsDialog.vue?vue&type=script&setup=true&lang=js"

import "./SchoolSettingsDialog.vue?vue&type=style&index=0&id=0cccf003&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cccf003"]])

export default __exports__